import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer style={{ background: 'var(--primary-dark)', color: 'rgba(255,255,255,0.85)', padding: '80px 0 40px' }}>
      <div className="container">
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 40, paddingBottom: 40, borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
              <div style={{ width: 38, height: 38, background: 'var(--accent)', color: 'var(--primary-dark)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'Playfair Display',serif", fontSize: '1.2rem', fontWeight: 700, borderRadius: 8 }}>H</div>
              <div>
                <div style={{ fontFamily: "'Playfair Display',serif", fontSize: '1.1rem', fontWeight: 700, color: 'white' }}>HICON</div>
                <div style={{ fontSize: '0.7rem', opacity: 0.7 }}>Testing Lab & Research Centre LLP</div>
              </div>
            </div>
            <p style={{ fontSize: '0.88rem', lineHeight: 1.7, opacity: 0.8, marginBottom: 16 }}>
              Central India's premier geotechnical investigation, materials testing, and civil engineering consultancy. NABL Accredited, ISO/IEC 17025:2017.
            </p>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
              {['NABL Accredited', 'ISO/IEC 17025:2017', 'LLPIN: ACE-7707'].map(b => (
                <span key={b} style={{ padding: '4px 10px', background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.15)', borderRadius: 4, fontSize: '0.72rem' }}>{b}</span>
              ))}
            </div>
          </div>

          <div>
            <h4 style={{ fontFamily: "'Playfair Display',serif", fontSize: '1rem', color: 'white', marginBottom: 16 }}>Services</h4>
            {[
              { label: 'Soil Investigation', path: '/geotechnical' },
              { label: 'SBC & CBR Testing', path: '/geotechnical' },
              { label: 'Concrete Testing', path: '/materials' },
              { label: 'NDT Services', path: '/materials' },
              { label: 'Equipment Supply', path: '/equipment' },
            ].map(l => (
              <Link key={l.label} to={l.path} style={{ display: 'block', fontSize: '0.85rem', opacity: 0.75, marginBottom: 10 }}>{l.label}</Link>
            ))}
          </div>

          <div>
            <h4 style={{ fontFamily: "'Playfair Display',serif", fontSize: '1rem', color: 'white', marginBottom: 16 }}>Company</h4>
            {[
              { label: 'About Us', path: '/about' },
              { label: 'Careers', path: '/careers' },
              { label: 'Contact', path: '/contact' },
            ].map(l => (
              <Link key={l.label} to={l.path} style={{ display: 'block', fontSize: '0.85rem', opacity: 0.75, marginBottom: 10 }}>{l.label}</Link>
            ))}
          </div>

          <div>
            <h4 style={{ fontFamily: "'Playfair Display',serif", fontSize: '1rem', color: 'white', marginBottom: 16 }}>Contact</h4>
            <p style={{ fontSize: '0.85rem', opacity: 0.75, marginBottom: 6 }}>H. No. 61, Narayan Nagar</p>
            <p style={{ fontSize: '0.85rem', opacity: 0.75, marginBottom: 6 }}>Hoshangabad Road, Bhopal</p>
            <p style={{ fontSize: '0.85rem', opacity: 0.75, marginBottom: 12 }}>Madhya Pradesh – 462043</p>
            <a href="tel:+919926159598" style={{ display: 'block', fontSize: '0.85rem', opacity: 0.75, marginBottom: 6 }}>+91 9926159598</a>
            <a href="tel:+917067434734" style={{ display: 'block', fontSize: '0.85rem', opacity: 0.75, marginBottom: 6 }}>+91 7067434734</a>
            <a href="mailto:hiconresurch@gmail.com" style={{ display: 'block', fontSize: '0.85rem', opacity: 0.75 }}>hiconresurch@gmail.com</a>
          </div>
        </div>

        <div style={{ paddingTop: 24, display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12 }}>
          <p style={{ fontSize: '0.8rem', opacity: 0.5 }}>&copy; {new Date().getFullYear()} Hicon Testing Lab Consultancy and Research Centre LLP. All rights reserved.</p>
          <p style={{ fontSize: '0.8rem', opacity: 0.5, fontStyle: 'italic' }}>Civil Engineering Testing Laboratory — Not a Medical Facility</p>
        </div>
      </div>
    </footer>
  );
}
